import InfoPage from '@/components/InfoPage';
import { Briefcase, Heart, Users, TrendingUp } from 'lucide-react';

const TrabalheConosco = () => {
  return (
    <InfoPage title="Trabalhe Conosco">
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Junte-se à Nossa Equipe</h2>
          <p className="text-gray-700 mb-6">
            Estamos sempre em busca de talentos apaixonados por tecnologia e mobilidade urbana. Se você acredita na democratização do acesso a estacionamentos e quer fazer parte dessa revolução, venha trabalhar conosco!
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-6" style={{ color: '#831D1C' }}>Por que trabalhar na ParkingSpot?</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-purple-50 p-6 rounded-lg">
              <Heart className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Propósito</h3>
              <p className="text-sm text-gray-600">Trabalhe em um projeto que impacta milhões de pessoas diariamente</p>
            </div>
            
            <div className="bg-purple-50 p-6 rounded-lg">
              <Users className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Equipe</h3>
              <p className="text-sm text-gray-600">Trabalhe com profissionais talentosos e apaixonados</p>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg">
              <TrendingUp className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Crescimento</h3>
              <p className="text-sm text-gray-600">Oportunidades constantes de aprendizado e desenvolvimento</p>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg">
              <Briefcase className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Flexibilidade</h3>
              <p className="text-sm text-gray-600">Trabalho remoto e horários flexíveis</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#009440' }}>Vagas Abertas</h2>
          <div className="space-y-4">
            <div className="border-l-4 border-[#302681] bg-gray-50 p-6 rounded">
              <h3 className="font-semibold text-lg mb-2">Desenvolvedor Full Stack</h3>
              <p className="text-gray-600 mb-3">São Paulo - Remoto</p>
              <p className="text-sm text-gray-700">Buscamos desenvolvedor com experiência em React, Node.js e MongoDB para trabalhar no desenvolvimento de novas funcionalidades.</p>
            </div>

            <div className="border-l-4 border-[#302681] bg-gray-50 p-6 rounded">
              <h3 className="font-semibold text-lg mb-2">Designer UI/UX</h3>
              <p className="text-gray-600 mb-3">São Paulo - Híbrido</p>
              <p className="text-sm text-gray-700">Profissional criativo para melhorar continuamente a experiência dos usuários em nossa plataforma.</p>
            </div>
          </div>
          
          <div className="mt-6 bg-blue-50 p-6 rounded-lg">
            <p className="font-semibold mb-2">Interessado?</p>
            <p className="text-gray-700">Envie seu currículo para: <a href="mailto:rh@parkingspot.com.br" className="text-[#302681] hover:underline">rh@parkingspot.com.br</a></p>
          </div>
        </section>
      </div>
    </InfoPage>
  );
};

export default TrabalheConosco;
